import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ChangeAlign } from "../../../reducers/editor";
import { RootState } from "../../../reducers";
import {
  RestoreSelection,
  snapshotEditorSelectionIfInScreen,
} from "../../../lib/lib";
const dummy = [
  { img: "left", type: "justifyLeft" },
  { img: "center", type: "justifyCenter" },
  { img: "right", type: "justifyRight" },
];
function Ftalign() {
  const dispatch = useDispatch();
  const nowState = useSelector<RootState, string>(
    (state) => state.editor.align
  );
  const __changeAlign = useCallback(
    (type: string) => {
      let data: string;
      if (type === "justifyCenter") {
        data = "center";
      } else if (type === "justifyRight") {
        data = "right";
      } else {
        data = "left";
      }

      dispatch(ChangeAlign(data));
      RestoreSelection();
      document.execCommand(type);
    },
    [dispatch]
  );
  return (
    <div className="ftalign-wrapper">
      {dummy.map(({ img, type }, idx) => {
        return (
          <button
            className="align-btn"
            key={idx}
            onMouseDown={(e) => {
              snapshotEditorSelectionIfInScreen();
              e.preventDefault();
            }}
            onClick={() => {
              __changeAlign(type);
            }}
          >
            <img
              src={`/assets/editor/${img}.svg`}
              alt={`${img}`}
              style={
                nowState !== img ? { filter: "grayscale(100%)" } : undefined
              }
            />
          </button>
        );
      })}
    </div>
  );
}

export default Ftalign;
